import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ClientFactoringByCesionarioDTO } from '../../minutes/interface/minute-request-kpis.interface';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-minute-factoring-factorization',
  templateUrl: './minute-factoring-factorization.component.html',
  styleUrls: ['./minute-factoring-factorization.component.scss']
})
export class MinuteFactoringFactorizationComponent implements OnInit, OnChanges {

  @Input() factoringByCesionario: Array<ClientFactoringByCesionarioDTO>;

  public dataSource!: MatTableDataSource<ClientFactoringByCesionarioDTO>;
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator =
  Object.create(null);
  public displayedColumns: string[] = ['cesionarioName', 'cesionarioRut', 'transferedInvoiceTotalAmount', 'numTransferedInvoices'];


  constructor(){
    this.factoringByCesionario = new Array<ClientFactoringByCesionarioDTO>();
  }

  ngOnInit(): void {
    this.setDataSource(this.factoringByCesionario);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setDataSource(this.factoringByCesionario);
  }

  private setDataSource(factoringCesionario: Array<ClientFactoringByCesionarioDTO>) {
    this.dataSource = new MatTableDataSource<ClientFactoringByCesionarioDTO>(factoringCesionario);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
